/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ChangeProgramNotes$Params {
  programId?: number;
  newNotes?: string;
  shouldMarkAsNew?: boolean;
}

export function ChangeProgramNotes(http: HttpClient, rootUrl: string, params?: ChangeProgramNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, ChangeProgramNotes.PATH, 'post');
  if (params) {
    rb.query('programId', params.programId, {});
    rb.query('newNotes', params.newNotes, {});
    rb.query('shouldMarkAsNew', params.shouldMarkAsNew, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

ChangeProgramNotes.PATH = '/api/Staff/ChangeProgramNotes';
